// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/Inter-VariableFont_slnt,wght.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --Orange: #fe6100;
  --Green: #87bc45;
  --Red: #e00606;
  --WhiteSmoke: #f5f5f5;
  --White: #fff;
  --StockOrange: #ff7b29;
  --StockRed: #e00606;
  --SaddleBrown: #833505;
  --TotalBlack: #000000;
  --HightEmphasis: #212121;
  --LightBlack: #0f1d3e;
  --MediumEmphasis: #666;
  --LowEmphasis: #9e9e9e;
  --Gray88: #e0e0e0;
  --Gray85: #d9d9d9; }

@font-face {
  font-family: 'Inter';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-style: normal;
  font-weight: 100 900; }

body {
  margin: 0;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; }

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  font-family: 'Inter';
  font-style: normal; }

.window {
  width: 100vw;
  height: 100vh;
  display: flex; }
  .window .outlet {
    width: calc(100vw - 160px);
    height: 100vh;
    background-color: #f5f5f5;
    overflow: auto;
    padding: 70px 30px 40px 30px; }
    @media screen and (max-width: 768px) {
      .window .outlet {
        width: 100%;
        padding: 0; } }

.hidden {
  display: none; }

.swiper-pagination-fraction {
  position: absolute !important;
  top: 20px !important;
  right: 10px !important;
  left: calc(100% - 70px) !important;
  padding: 5px 15px !important;
  color: white !important;
  width: max-content !important;
  height: max-content !important;
  background: #0000006b;
  border-radius: 21px; }

.swiper-button-disabled {
  opacity: 0 !important; }

.swiper-button-prev,
.swiper-button-next {
  width: 30px !important;
  height: 30px !important;
  background: #0000006b !important;
  border-radius: 50%;
  transition: all 0.5s; }
  .swiper-button-prev:hover,
  .swiper-button-next:hover {
    transform: scale(1.1); }
  .swiper-button-prev::after,
  .swiper-button-next::after {
    font-size: 20px !important;
    color: white !important; }

.preloader-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 0; }

.pointer {
  cursor: pointer; }

::-webkit-scrollbar {
  background-color: inherit;
  width: 6px; }

/* background of the scrollbar except button or resizer */
::-webkit-scrollbar-track {
  background-color: inherit; }

::-webkit-scrollbar-track:hover {
  background-color: #fff; }

/* scrollbar itself */
::-webkit-scrollbar-thumb {
  background-color: #babac0;
  border-radius: 16px;
  border: 0px solid #fff; }

::-webkit-scrollbar-thumb:hover {
  background-color: #a0a0a5;
  border: 1px solid #f4f4f4; }

/* set button(top and bottom of the scrollbar) */
::-webkit-scrollbar-button {
  display: none; }

.spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%; }

.circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 5px solid rgba(0, 0, 0, 0);
  border-top-color: #fe6100;
  border-left-color: #fe6100;
  border-bottom-color: #fe6100;
  animation: spin 1.2s ease-out infinite; }

@keyframes spin {
  from {
    transform: rotate(0deg); }
  to {
    transform: rotate(360deg); } }

.multi-range-slider {
  border: none !important;
  box-shadow: none !important; }
  .multi-range-slider .bar-left,
  .multi-range-slider .bar-right,
  .multi-range-slider .bar-inner,
  .multi-range-slider .thumb-left:before,
  .multi-range-slider .thumb-right:before {
    box-shadow: none !important;
    border: none; }
  .multi-range-slider .caption {
    pointer-events: none;
    display: flex;
    bottom: 25px !important; }
  .multi-range-slider .min-caption, .multi-range-slider .max-caption {
    padding: 0 !important;
    box-shadow: none !important;
    background-color: inherit !important;
    color: #666666 !important; }
`, "",{"version":3,"sources":["webpack://./src/styles/colors.scss","webpack://./src/index.scss"],"names":[],"mappings":"AAAA;EAEE,iBAAS;EACT,gBAAQ;EACR,cAAM;EACN,qBAAa;EACb,aAAQ;EACR,sBAAc;EACd,mBAAW;EACX,sBAAc;EAGd,qBAAa;EACb,wBAAgB;EAChB,qBAAa;EACb,sBAAiB;EACjB,sBAAc;EAGd,iBAAS;EACT,iBAAS,EAAA;;AClBX;EACE,oBAAoB;EACpB,4CAA4D;EAC5D,kBAAkB;EAClB,oBAAoB,EAAA;;AAGtB;EACE,SAAS;EACT,uKACsE;EACtE,mCAAmC;EACnC,kCAAkC,EAAA;;AAEpC;EACE,UAAU;EACV,SAAS;EACT,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB,EAAA;;AAEpB;EACE,YAAY;EACZ,aAAa;EACb,aAAa,EAAA;EAHf;IAKI,0BAA0B;IAC1B,aAAa;IACb,yBAAyB;IACzB,cAAc;IACd,4BAA4B,EAAA;IAE9B;MAXF;QAYI,WAAW;QACX,UAAU,EAAA,EAEX;;AAIH;EACE,aAAa,EAAA;;AAGf;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,sBAAsB;EACtB,kCAAkC;EAClC,4BAA4B;EAC5B,uBAAuB;EACvB,6BAA6B;EAC7B,8BAA8B;EAC9B,qBAAqB;EACrB,mBAAmB,EAAA;;AAErB;EACE,qBAAqB,EAAA;;AAGvB;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB,EAAA;EANtB;;IAQI,qBAAqB,EAAA;EARzB;;IAWI,0BAA0B;IAC1B,uBAAuB,EAAA;;AAI3B;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe,EAAA;;AAEjB;EACE,eAAe,EAAA;;AAEjB;EACE,yBAAyB;EACzB,UAAU,EAAA;;AAGZ,yDAAA;AACA;EACE,yBAAyB,EAAA;;AAG3B;EACE,sBAAsB,EAAA;;AAGxB,qBAAA;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB,EAAA;;AAGxB;EACE,yBAAyB;EACzB,yBAAyB,EAAA;;AAG3B,gDAAA;AACA;EACE,aAAa,EAAA;;AAGf;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY,EAAA;;AAGd;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;EAC5B,sCAAsC,EAAA;;AAGxC;EACE;IACE,uBAAuB,EAAA;EAEzB;IACE,yBAAyB,EAAA,EAAA;;AAI7B;EACE,uBAAuB;EACvB,2BAA2B,EAAA;EAF7B;;;;;IAQI,2BAA2B;IAC3B,YAAY,EAAA;EAThB;IAYI,oBAAoB;IACpB,aAAa;IACb,uBAAuB,EAAA;EAd3B;IAiBI,qBAAoB;IACpB,2BAA0B;IAC1B,oCAAmC;IACnC,yBAAuB,EAAA","sourcesContent":[":root {\n  // Product\n  --Orange: #fe6100;\n  --Green: #87bc45;\n  --Red: #e00606;\n  --WhiteSmoke: #f5f5f5;\n  --White: #fff;\n  --StockOrange: #ff7b29;\n  --StockRed: #e00606;\n  --SaddleBrown: #833505;\n\n  // On Surface\n  --TotalBlack: #000000;\n  --HightEmphasis: #212121;\n  --LightBlack: #0f1d3e;\n  --MediumEmphasis: #666;\n  --LowEmphasis: #9e9e9e;\n\n  // Border\n  --Gray88: #e0e0e0;\n  --Gray85: #d9d9d9;\n}\n","@import './styles/colors.scss';\n\n@font-face {\n  font-family: 'Inter';\n  src: url('./assets/fonts/Inter-VariableFont_slnt\\,wght.ttf');\n  font-style: normal;\n  font-weight: 100 900;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu',\n    'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n* {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n  font-family: 'Inter';\n  font-style: normal;\n}\n.window {\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  .outlet {\n    width: calc(100vw - 160px);\n    height: 100vh;\n    background-color: #f5f5f5;\n    overflow: auto;\n    padding: 70px 30px 40px 30px;\n\n  @media screen and (max-width: 768px) {\n    width: 100%;\n    padding: 0;\n    }\n  }\n\n}\n\n.hidden {\n  display: none;\n}\n\n.swiper-pagination-fraction {\n  position: absolute !important;\n  top: 20px !important;\n  right: 10px !important;\n  left: calc(100% - 70px) !important;\n  padding: 5px 15px !important;\n  color: white !important;\n  width: max-content !important;\n  height: max-content !important;\n  background: #0000006b;\n  border-radius: 21px;\n}\n.swiper-button-disabled {\n  opacity: 0 !important;\n}\n\n.swiper-button-prev,\n.swiper-button-next {\n  width: 30px !important;\n  height: 30px !important;\n  background: #0000006b !important;\n  border-radius: 50%;\n  transition: all 0.5s;\n  &:hover {\n    transform: scale(1.1);\n  }\n  &::after {\n    font-size: 20px !important;\n    color: white !important;\n  }\n}\n\n.preloader-wrapper {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px 0;\n}\n.pointer {\n  cursor: pointer;\n}\n::-webkit-scrollbar {\n  background-color: inherit;\n  width: 6px;\n}\n\n/* background of the scrollbar except button or resizer */\n::-webkit-scrollbar-track {\n  background-color: inherit;\n}\n\n::-webkit-scrollbar-track:hover {\n  background-color: #fff;\n}\n\n/* scrollbar itself */\n::-webkit-scrollbar-thumb {\n  background-color: #babac0;\n  border-radius: 16px;\n  border: 0px solid #fff;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background-color: #a0a0a5;\n  border: 1px solid #f4f4f4;\n}\n\n/* set button(top and bottom of the scrollbar) */\n::-webkit-scrollbar-button {\n  display: none;\n}\n\n.spinner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n.circle {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 5px solid rgba(0, 0, 0, 0);\n  border-top-color: #fe6100;\n  border-left-color: #fe6100;\n  border-bottom-color: #fe6100;\n  animation: spin 1.2s ease-out infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.multi-range-slider {\n  border: none !important;\n  box-shadow: none !important;\n  .bar-left,\n  .bar-right,\n  .bar-inner,\n  .thumb-left:before,\n  .thumb-right:before {\n    box-shadow: none !important;\n    border: none;\n  }\n  .caption {\n    pointer-events: none;\n    display: flex;\n    bottom: 25px !important;\n  }\n  .min-caption, .max-caption {\n    padding: 0!important;\n    box-shadow: none!important;\n    background-color: inherit!important;\n    color:#666666!important\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
